import React from 'react';
import { useSpring, animated } from 'react-spring';

const Gallery = () => {
  const images = [
    // Add your image URLs here
    'image1.jpg',
    'image2.jpg',
    'image3.jpg',
  ];

  const fadeIn = useSpring({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 1000 },
  });

  return (
    <animated.div style={fadeIn} className="container mx-auto py-16">
      <h2 className="text-4xl font-bold text-center mb-8">Gallery</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {images.map((image, index) => (
          <div key={index} className="overflow-hidden rounded-lg shadow-lg">
            <img src={`/assets/images/${image}`} alt={`Event ${index + 1}`} className="w-full h-64 object-cover" />
          </div>
        ))}
      </div>
    </animated.div>
  );
};

export default Gallery;